import React from 'react';

import { useBodyTypesFilter } from '@/hooks/filters/body-types-filter.hook';
import { useBrandsRangesFilter } from '@/hooks/filters/brands-ranges-filter.hook';
import { useFiltersQuery } from '@/hooks/used-cars/filters-query.hook';
import { useProvincesDealershipsFilter } from '@/hooks/used-cars/provinces-dealerships-filter.hook';
import { getAllPriceRanges } from '@/services/CarService.service';
import { makeKiaFirst } from '@/services/filters/filters.service';
import { mapBrowseItem } from '@/services/used-cars/used-cars.service';
import { CarFilter, ParentFilter } from '@/types/filters/filters.types';
import { BrowseTypes, VehicleType } from '@/types/used-cars/used-cars.types';

import { BlockWrapper } from '../block-wrapper/block-wrapper';
import { BodyBrowseItem } from '../browse-section/browse-item/body-browse-item';
import { BrandBrowseItem } from '../browse-section/browse-item/brand-browse-item';
import { BrowseLocationItem } from '../browse-section/browse-item-location/browse-location-item';
import { BrowseSection } from '../browse-section/browse-section';
import { CarSpecials } from '../car-specials/car-specials';
import { HeadingSection } from '../heading-section/heading-section';
import { PopularCars } from '../popular-cars/popular-cars';

import styles from './page-content.module.scss';

export const PageContent: React.FC<{
  headingContentText: string;
  headingContentTextDemo: string;
  brands: ParentFilter[];
  bodyTypes: CarFilter[];
  provinces: ParentFilter[];
  carType: VehicleType;
  activeDealershipId?: string;
}> = ({
  headingContentText,
  headingContentTextDemo,
  brands = [],
  bodyTypes = [],
  provinces = [],
  carType = VehicleType.Used,
  activeDealershipId,
}) => {
  const { brandsRangesFilter } = useBrandsRangesFilter();
  const { visibleBodyTypes } = useBodyTypesFilter();
  const { provincesDealershipsFilter } = useProvincesDealershipsFilter();
  const { activeCarType } = useFiltersQuery();
  const priceRange = getAllPriceRanges();

  const allBrands = brandsRangesFilter.length ? brandsRangesFilter : brands;
  const allVisibleBodyTypes = visibleBodyTypes.length
    ? visibleBodyTypes
    : bodyTypes;
  const allProvinces = provincesDealershipsFilter.length
    ? provincesDealershipsFilter
    : provinces;
  const actualActiveCarType = activeCarType ? activeCarType : carType;

  return (
    <div className={styles.bodyWrapper}>
      <BlockWrapper>
        <HeadingSection
          headingContentText={headingContentText}
          headingContentTextDemo={headingContentTextDemo}
          carType={actualActiveCarType}
        />
        <>
          <>
            {actualActiveCarType !== VehicleType.Demo ? (
              <BrowseSection
                name={BrowseTypes.brand}
                data={mapBrowseItem(makeKiaFirst(allBrands))}
                buttonText={'View All'}
                item={BrandBrowseItem as any}
              />
            ) : null}
            <BrowseSection
              name={BrowseTypes.body}
              data={mapBrowseItem(allVisibleBodyTypes)}
              buttonText={'View All'}
              item={BodyBrowseItem as any}
            />
            <BrowseSection
              name={BrowseTypes.price}
              data={priceRange as any}
              item={BrandBrowseItem as any}
            />
          </>
          {activeDealershipId ? null : (
            <BrowseSection
              name={BrowseTypes.location}
              data={mapBrowseItem(allProvinces)}
              buttonText="View All"
              item={BrowseLocationItem}
            />
          )}
        </>
      </BlockWrapper>
      <PopularCars
        description={headingContentText}
        descriptionDemo={headingContentTextDemo}
      />
      <CarSpecials
        description={headingContentText}
        descriptionDemo={headingContentTextDemo}
        carType={actualActiveCarType}
      />
    </div>
  );
};
